import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Media from 'components/common/Media'
import Play from '../assets/play-in-circle.svg'
import Pause from '../assets/pause-in-circle.svg'
import PlayFilled from '../assets/play-in-circle-filled.svg'
import PauseFilled from '../assets/pause-in-circle-filled.svg'
import { CUSTOM_PLAY_PAUSE_BUTTON_CLASS } from '../../../constants'

export const CustomPlayPauseButton = ({ togglePlayPause, isPlaying }) =>
  <Button
    className={ CUSTOM_PLAY_PAUSE_BUTTON_CLASS }
    aria-label={ isPlaying ? 'Pause Carousel' : 'Play Carousel' }
    isPlaying={ isPlaying }
    onClick={ togglePlayPause } />

CustomPlayPauseButton.propTypes = {
  isPlaying: PropTypes.bool,
  togglePlayPause: PropTypes.func
}

const Button = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent !important;
  cursor: pointer;

  &::after {
    width: 24px;
    height: 24px;
    ${props => props.isPlaying && css`
      content: url(${Pause})
    `}
    ${props => !props.isPlaying && css`
      content: url(${Play})
    `}
  }

  ${Media.desktop`
    &:hover {
      &::after {
        ${props => props.isPlaying && css`
        content: url(${PauseFilled})
      `}
      ${props => !props.isPlaying && css`
        content: url(${PlayFilled})
      `}
      }
    }
  `}
`

